export default __webpack_public_path__ + "static/media/Asset 1.4554cd0b.png";